import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData        from '../primitives/localData'
import lmx_Watching         from './Watching'
import lmx_Events           from './Events'
  
// Charts 
import lmx_LocalValues      from './set_LocalValues'
import lmx_draw_Forms       from './draw_Forms'
import lmx_draw_Scrollbar   from './draw_Scrollbar'
import lmx_draw_Header      from './draw_Header'
import lmx_draw_dataGroups  from './draw_dataGroups'
import lmx_draw_dataValues  from './draw_dataValues'
import verifyErrors         from './verifyErrors'
import lmx_PDF              from './PDF'


export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_localData,
    lmx_Events,
    lmx_Watching,

    lmx_LocalValues,
    lmx_draw_Forms,
    lmx_draw_Scrollbar,
    lmx_draw_Header,
    lmx_draw_dataGroups,
    lmx_draw_dataValues,
    verifyErrors,
    lmx_PDF,

  ],

}
